import { produce } from 'immer';
import update from 'immutability-helper';
import { BlockTypes, BlockStatus, SignerStatus } from '../../common/constants';
import { ActionTypes } from '../actions';
import type { IBlock, IDocument } from '../types';

export interface IBlockState {
  [documentId: string]: {
    [pageNumber: number]: {
      [blockId: string]: IBlock;
    };
  };
}

export function blocksReducer(state: IBlockState = {}, action: any) {
  switch (action.type) {
    case ActionTypes.FETCH_ENVELOPE_DONE: {
      const envelope = action.payload;
      const { serverTime } = action.payload;
      if (envelope.signer.signingStatus === SignerStatus.COMPLETE) {
        return state;
      }

      const blocks: IBlockState = {};
      envelope.documents.forEach((doc: IDocument) => {
        const docId = doc.documentId;
        if (!blocks[docId]) {
          blocks[docId] = {};
        }
        doc.blocks.forEach((block) => {
          if (!blocks[docId][block.pageNumber]) {
            blocks[docId][block.pageNumber] = {};
          }
          if (block.height && !block.fontSize) {
            block.fontSize = 12;
          }
          if (block.status === BlockStatus.COMPLETE) {
            block.signed = true;
            block.status = BlockStatus.COMPLETE;
          } else if (block.blockType === BlockTypes.DATE_SIGNED || block.blockType === BlockTypes.TIME_SIGNED) {
            block.value = serverTime;
            block.status = BlockStatus.COMPLETE;
          } else if (block.blockType === BlockTypes.FULLNAME) {
            // Full Name blocks are auto-populated, so set to Complete
            block.status = BlockStatus.COMPLETE;
          } else if (block.blockType === BlockTypes.CHECKBOX && block.value === null) {
            block.value! = false;
          }
          if (block.blockType === BlockTypes.CHECKBOX && block.value) {
            block.status = BlockStatus.COMPLETE;
          }
          if (block.blockType === BlockTypes.TEXT && !block.required) {
            block.status = BlockStatus.COMPLETE;
          }
          blocks[docId][block.pageNumber][block.blockId] = block;
        });
      });
      return blocks;
    }
    case ActionTypes.SIGN_FIELD: {
      const { documentId, blockId, pageNumber } = action.payload;
      return produce(state, (draftState) => {
        draftState[documentId][pageNumber][blockId].status = BlockStatus.COMPLETE;
      });
    }
    case ActionTypes.UPDATE_BLOCK: {
      const { documentId, pageNumber, blockId, blockUpdate } = action.payload;
      const block = state[documentId][pageNumber][blockId];
      if (blockUpdate.blockType === BlockTypes.TEXT && block.required) {
        if (blockUpdate.value.length > 0) {
          blockUpdate.status = BlockStatus.COMPLETE;
        } else {
          blockUpdate.status = BlockStatus.PENDING;
        }
      }
      return update(state, {
        [documentId]: {
          [pageNumber]: {
            [blockId]: { $set: { ...state[documentId][pageNumber][blockId], ...blockUpdate } },
          },
        },
      });
    }
    case ActionTypes.COMPLETE_BLOCKS_IN_GROUP: {
      const { blocks }: { blocks: IBlock[] } = action.payload;
      const { documentId, pageNumber, groupId } = blocks[0];
      const blocksToUpdate = state[documentId][pageNumber];
      blocks.forEach((block) => {
        const currentBlock: IBlock = blocksToUpdate[block.blockId];
        if (currentBlock.groupId === groupId) {
          currentBlock.status = BlockStatus.COMPLETE;
        }
      });

      return update(state, {
        [documentId]: {
          [pageNumber]: {
            $set: {
              ...blocksToUpdate,
            },
          },
        },
      });
    }
    case ActionTypes.SUBMIT_ENVELOPE_DONE: {
      return {};
    }
    default: {
      return state;
    }
  }
}
